export const SKIP_WASTE_TYPES = [
  {
    label: "common.skipWasteTypes.mixedGeneralWaste",
    value: "Mixed",
  },
  {
    label: "common.skipWasteTypes.bulkyWaste",
    value: "Bulky",
  },
  {
    label: "common.skipWasteTypes.lightConstructionWaste",
    value: "LightConstruction",
  },
  {
    label: "common.skipWasteTypes.heavyConstructionWaste",
    value: "HeavyConstruction",
  },
  {
    label: "common.skipWasteTypes.soil",
    value: "Soil",
  },
] as const;

export type WasteType = typeof SKIP_WASTE_TYPES[number]["value"];

export const API_SKIP_WASTE_TYPES: Record<WasteType, string> = {
  Mixed: "Mixed Municipal (20 03 01)",
  Bulky: "Bulky Waste (20 03 07)",
  LightConstruction: "Construction (17 09 04)",
  HeavyConstruction: "Construction (17 09 04)",
  Soil: "Soil (17 05 04)",
};
